import { Component, type ErrorInfo, type ReactNode } from 'react';

import { Fallback } from './fallback';

interface ErrorBoundaryProps {
    children: ReactNode;
    logger?: {
        error: (error: Error, errorInfo: ErrorInfo) => void;
    };
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

export class ErrorBoundary extends Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    constructor(props: ErrorBoundaryProps) {
        super(props);

        this.state = {
            hasError: false,
            error: null,
        };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        console.error(error, errorInfo);
        this.props.logger?.error(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <Fallback />;
        }

        return this.props.children;
    }
}
